import React from 'react';
import { Link } from 'react-router-dom'

function ProcDig () {
    return (
        <div className="espacio">
            <p class="h1 text-center">Procesos Digitales</p>
        <div class="row container-fluid align-items-center espacio">
            
            <div class="col-sm-6">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">Recursos Humanos</h5>
                    <Link to="/rechum">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_63/v1611108547/ARBAL/SIAR/WhatsApp_Image_2021-01-19_at_8.05.55_PM.jpg" class="img-thumbnail" alt="..."></img>
                    </Link>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">Operaciones</h5>
                    <Link to="/construc">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1604529675/ARBAL/SIAR/rh.png" class="img-thumbnail" alt="..."></img>
                    </Link>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
            <div class="col-sm-6 espacio">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">Contabilidad</h5>
                    <Link to="/construc">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1604529675/ARBAL/SIAR/conta_2.png" class="img-thumbnail" alt="..."></img>
                    </Link>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
            <div class="col-sm-6 espacio">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">Vehículos</h5>
                    <Link to="/construc">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1604529675/ARBAL/SIAR/vehiculos.png" class="img-thumbnail" alt="..."></img>
                    </Link>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default ProcDig